import { CIcon } from '~/icons/types'
export const ciStar: CIcon = {
  width: 25,
  height: 24,
  paths: [
    {
      d:
        'm23.569 7.646-6.553-.95-2.93-5.902c-.524-1.052-2.045-1.065-2.575 0L8.583 6.697l-6.554.95C.853 7.815.382 9.255 1.234 10.08l4.742 4.592-1.122 6.487c-.202 1.172 1.04 2.05 2.082 1.502l5.863-3.062 5.863 3.063c1.04.544 2.284-.33 2.082-1.502l-1.122-6.487 4.742-4.592c.852-.825.38-2.265-.795-2.435Zm-6.257 6.278 1.063 6.17-5.576-2.91-5.576 2.91 1.063-6.17-4.513-4.37 6.236-.9 2.79-5.617 2.79 5.617 6.236.9-4.513 4.37Z'
    }
  ],
  name: 'star',
  type: 'regular'
}
